import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=e3989010&"
import script from "./MessageHeader.vue?vue&type=script&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports